import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { GetCustomerBenefitsQuery } from '@notino/shared/definitions/types';

import { benefitsModalTableMessages } from './messages';
import {
  BenefitsModalTableLine,
  BenefitsModalTableWrapper,
  BrandName,
} from './styled';

interface IBenefitsModalTableProps {
  customerBenefits: GetCustomerBenefitsQuery['customerBenefits'];
}

export const BenefitsModalTable: React.FC<IBenefitsModalTableProps> = ({
  customerBenefits,
}) => {
  const availableDiscounts = new Array(
    customerBenefits.brandDiscountLimit +
      customerBenefits.categoryDiscountLimit -
      (customerBenefits.brandDiscounts.length +
        customerBenefits.categoryDiscounts.length)
  ).fill(0);

  return (
    <BenefitsModalTableWrapper>
      {customerBenefits.brandDiscounts.map((brandDiscount) => (
        <BenefitsModalTableLine key={brandDiscount.subjectName}>
          <BrandName title={brandDiscount.subjectName}>
            {brandDiscount.subjectName}
          </BrandName>
          <span>-{brandDiscount.value}%</span>
        </BenefitsModalTableLine>
      ))}
      {customerBenefits.categoryDiscounts.map((brandDiscount) => (
        <BenefitsModalTableLine key={brandDiscount.subjectName}>
          <BrandName title={brandDiscount.subjectName}>
            {brandDiscount.subjectName}
          </BrandName>
          <span>-{brandDiscount.value}%</span>
        </BenefitsModalTableLine>
      ))}
      {availableDiscounts.map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <BenefitsModalTableLine isOpaque={true} key={`notChosenLine-${i}`}>
          <BrandName>
            <FormattedMessage {...benefitsModalTableMessages.notChosen} />
          </BrandName>
          <span>0%</span>
        </BenefitsModalTableLine>
      ))}
    </BenefitsModalTableWrapper>
  );
};
